const jQuery = require('jquery');
window.$ = window.jQuery = jQuery;

require('../libs/bootstrap/transition');
require('../libs/bootstrap/collapse');

jQuery.noConflict(true);



// WEBPACK FOOTER //
// ./scripts/bootstrapComponents.js